import { ICorredor, ICorredorPayload } from '../types/corredor.type';
import $http from '../services/AxiosInstance';

interface Params {
  page?: number;
  search?: string;
  deleted?: boolean;
}

class CorredoresABMRepository {
  static async getCorredoresProPaginated(params: Params = {}) {
    try {
      let url = `/corredores/pro`;
      if (params.page) {
        url += `?page=${params.page}`;
      }
      if (params.search) {
        url += `&search=${params.search}`;
      }
      if (params.deleted) {
        url += `&deleted=${params.deleted}`;
      }
      const response = await $http.get(url);
      return response.data;
    } catch (errors: any) {
      throw Error;
    }
  }

  static async getCorredores() {
    try {
      const response = await $http.get('/corredores');
      return response.data;
    } catch (errors: any) {
      throw Error;
    }
  }

  static async createCorredor(data: ICorredorPayload): Promise<ICorredor> {
    const response = await $http.post('/corredores', data);
    return response.data;
  }

  static async updateCorredor(data: ICorredorPayload & { id: number }): Promise<ICorredor> {
    const response = await $http.patch(`/corredores/${data.id}`, data);
    return response.data;
  }

  static async deleteCorredor(id: number): Promise<void> {
    try {
      const response = await $http.delete(`/corredores/${id}`);
      return response.data;
    } catch (error) {
      throw Error;
    }
  }

  static async restoreCorredor(id: number): Promise<ICorredor> {
    try {
      const response = await $http.patch(`/corredores/${id}/restore`, {});
      return response.data;
    } catch (error) {
      throw Error;
    }
  }
}

export default CorredoresABMRepository;
